// extracted by mini-css-extract-plugin
export default {"container":"ProductListThumbnail_container__QeRlv","name":"ProductListThumbnail_name__lWlQp","wrapper":"ProductListThumbnail_wrapper__YhRpz"};